export const withoutColPadding = { flexboxgrid: { gutterWidth: 0.3 } };
